import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { PageTypeEnumValidationSchema } from '../page/enum';

export const FieldPageTypeValidationSchema = PageTypeEnumValidationSchema.meta({
  description:
    'The kind of page the field belongs to: `checkout`, `form`, or `event`. Use the type of the tool you fetched the page with (get_checkout_page, get_form, get_event).',
  example: 'checkout',
});

export const FieldPageParamsValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the page the field belongs to.',
  }),
  pageType: FieldPageTypeValidationSchema,
});

export const FieldParamsValidationSchema = FieldPageParamsValidationSchema.extend({
  fieldId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the field. Field IDs are listed under `fields` in the page detail response from get_checkout_page, get_form, or get_event.',
  }),
});
